import axios from "@/api/axiosInstance";
import { ListPublishedLibraryModulesResponse } from "./types";

export interface ListPublishedLibraryModulesParams {
  /** Optional case-insensitive difficulty/level filter. */
  difficulty?: string;
}

export const listPublishedLibraryModules = async (
  params: ListPublishedLibraryModulesParams = {},
): Promise<ListPublishedLibraryModulesResponse> => {
  const response = await axios.get<ListPublishedLibraryModulesResponse>(
    "/api/private/learning-center/module-library/published",
    {
      params: params.difficulty ? { difficulty: params.difficulty } : undefined,
    },
  );
  return response.data;
};
